import _ from 'lodash'
import moment from 'moment-mini'
import { PickerType, TimeType } from '../constants'
import TimeCell from '../TimeCell'

export default {
  name: 'KDatePickerTime',
  inject: ['context'],
  provide() {
    return {
      picker: this,
    }
  },
  props: {
    disabled: Boolean,
  },
  data() {
    return {
      pickerType: PickerType.Time,
      referenceValue: moment(),
      is24Hour: false,
      morning: true,
    }
  },
  computed: {
    value() {
      return this.context.value
    },
    active() {
      return this.context.active
    },
    defaultReferenceValue() {
      return this.context.referenceValue
    },
    hour() {
      return this.referenceValue && this.referenceValue.hour()
    },
    minute() {
      return this.referenceValue && this.referenceValue.minute()
    },
    second() {
      return this.referenceValue && this.referenceValue.second()
    },
    precision() {
      return this.context.precision
    },
    innerPrecision() {
      return _.find(TimeType, ['value', _.lowerCase(this.context.precision)]).precision
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        const referenceValue = this.value || this.defaultReferenceValue || moment()
        switch (this.precision) {
          case 'hour':
            referenceValue.minute(0)
            referenceValue.second(0)
            break
          case 'minute':
            referenceValue.second(0)
            break
          case 'second':
          default:
        }

        referenceValue.millisecond(0)
        this.referenceValue = referenceValue
      },
    },
    active: {
      handler(value) {
        if (value) {
          const referenceValue = this.value || this.defaultReferenceValue || moment()
          switch (this.precision) {
            case 'hour':
              referenceValue.minute(0)
              referenceValue.second(0)
              break
            case 'minute':
              referenceValue.second(0)
              break
            case 'second':
            default:
          }

          referenceValue.millisecond(0)
          this.referenceValue = referenceValue
        } else {
          this.$emit('pick', this.referenceValue)
        }
      },
    },
    referenceValue: {
      // immediate: true,
      handler(value, preValue) {
        if (preValue && value) {
          if (!preValue.isSame(value, this.precision)) {
            this.$emit('pick', value)
          }
        } else {
          this.$emit('pick', value)
        }
      },
    },
  },
  created() {
  },
  methods: {
    renderCell(meta) {
      const precision = meta.precision
      if (precision < this.innerPrecision) {
        return
      }

      const props = {
        value: this[meta.value],
        type: meta.value,
        disabled: this.disabled,
      }

      const events = {
        input: (value) => {
          this.referenceValue = this.referenceValue.clone()[meta.value](value)
        },
      }

      const data = {
        props,
        on: events,
      }

      return (
        <TimeCell
          {...data}
        />
      )
    },
  },
  render() {
    const css = {
      'km-time-picker__pane': true,
    }

    const data = {
      class: css,
    }

    const hourCell = this.renderCell(TimeType.hour)
    const minuteCell = this.renderCell(TimeType.minute)
    const secondCell = this.renderCell(TimeType.second)

    return (
      <div class="km-time-picker__pane-wrapper">
        <div {...data}>
          {hourCell}
          {
            hourCell && minuteCell
              ? <span class="km-time-picker__separator">:</span>
              : null
          }
          {minuteCell}
          {
            minuteCell && secondCell
              ? <span class="km-time-picker__separator">:</span>
              : null
          }
          {secondCell}
        </div>
      </div>
    )
  },
}
